<div class="col-sm-12">
  <app-card [cardOptionBtnValue]="'global.edit'|translate"
            [cardOptionBtn]="true"
            [cardRouterLink]="'/back-office/option/' + option.id"
            [title]="'admin.option.show.option_information'|translate">
    <div class="row">
      <div class="col-sm-12 col-xl-3">
        <p class="text-muted m-b-10">{{'doctrine.option.name'|translate}}</p>
        <label class="m-b-15">{{option.name}}</label>
      </div>
      <div class="col-sm-12 col-xl-3">
        <p class="text-muted m-b-10">{{'doctrine.option.code'|translate}}</p>
        <label class=" m-b-15">
          {{option.code}}
        </label>
      </div>
      <div class="col-sm-12 col-xl-3">
        <p class="text-muted m-b-10">{{'doctrine.option.active_modals'|translate}}</p>
        <label *ngIf="uniqueActiveModels.length > 0">
          <div class="tooltip-item">
            <a class="tooltipBox">
              {{uniqueActiveModels.length}}
            </a>
            <div class="desc-place" *ngIf="uniqueActiveModels.length>0">
              <ul>
                <ng-container *ngFor="let activeModel of uniqueActiveModels; let i = index;">
                  <span>
                    {{activeModel.name}}{{(i !== (uniqueActiveModels.length - 1)) ? ',' : ''}}
                  </span>
                </ng-container>
              </ul>
            </div>

          </div>

        </label>
        <label *ngIf="!activeModels.length">0</label>
      </div>
      <div class="col-sm-12 col-xl-3">
        <p class="text-muted m-b-10">{{'doctrine.option.status'|translate}}</p>
        <label class="m-b-15">
          {{(option.status ? 'global.active' : 'global.inactive') | translate}}</label>
      </div>
    </div>
  </app-card>
  <app-card
    (outputButton)="addOption()"
    [title]="'admin.option.show.options'|translate">

    <nav ngbNav #nav="ngbNav" class="nav nav-tabs">
      <ng-container ngbNavItem>
        <a ngbNavLink class="nav-link">{{'admin.option.show.options.tab.options'|translate}}</a>
        <ng-template ngbNavContent>
          <div class="table-responsive">
            <table class="table table-hover">
              <thead>
              <tr>
                <th>{{'doctrine.option.name'|translate}}</th>
                <th>{{'doctrine.option.type'|translate}}</th>
                <th>{{'doctrine.option.required'|translate}}</th>
                <th>{{'doctrine.option.dealer_price'|translate}}</th>
                <th>{{'doctrine.option.customer_price'|translate}}</th>
                <th>{{'doctrine.option.price_multiplier'|translate}}</th>
                <!--<th>{{'doctrine.option.multiplier'|translate}}</th>-->
                <th>{{'doctrine.option.position'|translate}}</th>
                <!--<th>{{'doctrine.option.code'|translate}}</th>-->
                <!--<th>{{'doctrine.option.status'|translate}}</th>-->
                <th>{{'global.actions'|translate}}</th>
              </tr>
              </thead>
              <tbody>
              <ng-container *ngFor="let item of options;let i = index">
                <tr>
                  <td>{{item.name}}</td>
                  <td>{{item.type}}</td>
                  <td>{{((item.required) ? 'global.yes' : 'global.no')|translate}}</td>
                  <td>{{item.dealerPrice| BackofficeCurrency:'EUR':'symbol-narrow':'4.2-2'}}</td>
                  <td>{{item.customerPrice| BackofficeCurrency:'EUR':'symbol-narrow':'4.2-2'}}</td>
                  <td>{{item.priceMultiplier ? item.priceMultiplier.name : ''}}</td>
                  <td>
                    <input class="form-control" (blur)="positionChange(item.id,item.parentPosition)"
                           [name]="positionItem+i"
                           type="number" [(ngModel)]="item.parentPosition" #positionItem="ngModel" style="max-width: 60px">
                  </td>
                  <!--<td>{{ item.code }}</td>-->
                  <!--<td>{{item.status ? getOption().OPTION_ACTIVE : getOption().OPTION_INACTIVE}}</td>-->
                  <td>
                    <ng-container *ngIf="!archive">
                      <span class="action-button">
                        <a class="ripple light ms-2"
                             (click)="manageOption(item)">
                          <i class="fa fa-pencil fa-lg"></i>
                        </a>
                      </span>
                      <span class="action-button">
                        <a class="ripple light ms-2"
                             (click)="setDetailForSoftDelete(item.id, item.name)">
                          <i class="fa fa-remove fa-lg"></i>
                        </a>
                      </span>
                    </ng-container>
                    <ng-container *ngIf="archive">
                      <span class="action-button">
                        <a class="ripple light ms-2"
                             (click)="showReAddForSubOption(item.id, item.name)">
                          <i class="fa fa-plus fa-lg"></i>
                        </a>
                      </span>
                    </ng-container>
                  <td>
                </tr>
                <!--<app-child-item [child]="options"></app-child-item>-->
                <ng-container
                  *ngTemplateOutlet="tree; context: { $implicit: item.options, idx: i, itemOp:item  }">

                </ng-container>
              </ng-container>
              </tbody>
            </table>
          </div>
          <button *ngIf="!archive" type="button" class="btn btn-simple ripple me-2 btn-primary light"
                  (click)="addOption()">
            <span class="feather icon-plus"></span> {{'global.add'|translate}}
          </button>
          <button class="btn btn-primary ripple light pull-right my-3" *ngIf="!archive" (click)="loadArchivedOptions()"
                  type="button">{{'global.view_archive'|translate}}</button>
          <button class="btn btn-primary ripple light pull-right my-3" *ngIf="archive" (click)="loadOptions()"
                  type="button">{{'admin.option.view_options'|translate}}</button>
        </ng-template>
      </ng-container>
      <ng-container ngbNavItem>
        <a ngbNavLink class="nav-link">{{'admin.option.show.options.tab.products'|translate}}</a>
        <ng-template ngbNavContent>
          <div class="row" *ngIf="!isLoading">
            <div class="col-sm-6 filter-box">
              <ngx-treeview
                [config]="config"
                [items]="items"
                [itemTemplate]="itemTemplate"
                (selectedChange)="onSelectedChange($event)"
                (filterChange)="onFilterChange($event)">
              </ngx-treeview>
            </div>
          </div>
          <div class="row">
            <!-- Loading Style -->
            <div class="preloader3 loader-block mx-auto" *ngIf="isLoading">
              <div class="circ1 loader-success"></div>
              <div class="circ2 loader-success"></div>
              <div class="circ3 loader-success"></div>
            </div>
          </div>
          <div class="card-block-hid ng-trigger ng-trigger-cardToggle" style="overflow: hidden;">
            <div class="card-block pull-right">
              <button (click)="setProducts(false)" class="btn btn-link me-4"
                      type="button">{{'global.cancel'|translate}}</button>
              <button (click)="setProducts(true)" class="btn btn-primary ripple light"
                      type="button">{{'global.save_changes'|translate}}</button>
            </div>
          </div>


        </ng-template>
      </ng-container>
    </nav>
    <div [ngbNavOutlet]="nav" class="mt-2"></div>

  </app-card>
</div>
<!--
 start soft delete modal
-->
<app-modal-basic #deleteModal>
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'global.soft_delete_title' | translate:{entity: 'Option'} }}</h4>
    <button type="button" class="close basic-close" (click)="deleteModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p>{{ 'global.soft_delete_body' | translate}}: <span [innerHTML]="optionName"></span> ?</p>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4"
            (click)="deleteModal.hide()">{{'global.cancel'|translate}}</button>
    <button type="button" class="btn btn-primary ripple light"
            (click)="softDelete()">{{'global.actions.delete'|translate}}</button>
  </div>
</app-modal-basic>

<!--
end soft delete modal
-->
<!--
start add sub option modal
-->
<app-modal-basic #optionModal [dialogClass]="'modal-lg'">
  <div class="app-modal-header">
    <h4
      class="modal-title">{{(isEdit ? 'global.soft_edit_title' : 'global.soft_add_title') | translate:{entity: 'Option'} }}</h4>
    <button type="button" class="close basic-close" (click)="optionModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <form novalidate #addNewOption="ngForm">
      <h4 class="sub-title">{{'doctrine.option.set_name' |translate}}</h4>
      <div class="form-group row">
        <ng-container *ngFor="let field of newOption.translationKeys">
          <ng-container *ngFor="let t of newOption.translationEntries[field]; let j=index">
            <div class="col-sm-4">
              <label class="float-label">{{'doctrine.package.name'|translate}} ({{ this.languageMap[t[0]]}})
                <span>*</span> </label>


              <input type="text" [name]="'nameItem'+j" #nameItem="ngModel"
                     [(ngModel)]="newOption.translations[field][t[0]]"
                     class="form-control" required>
              <div class="messages text-danger" *ngIf="nameItem.invalid && nameItem.dirty && nameItem.errors?.required">
                {{'errors.required'|translate}}
              </div>


            </div>
          </ng-container>
        </ng-container>
      </div>
      <h4 class="sub-title">{{'doctrine.option.type' |translate}}</h4>
      <div class="form-group row">
        <div class="form-group form-default form-static-label col-6">
          <label class="float-label">{{'doctrine.option.type'|translate}} <span class="star">*</span></label>
          <ng-select class="ng-select" name="type" #type="ngModel" [(ngModel)]="newOption.type" [clearable]="false"
                     required>
            <ng-option [value]="getOption().OPTION_TYPE_SELECT">{{'admin.option.type.select'|translate}}</ng-option>
            <ng-option [value]="getOption().OPTION_TYPE_FABRIC">{{'admin.option.type.fabric'|translate}}</ng-option>
            <ng-option [value]="getOption().OPTION_TYPE_OPTION">{{'admin.option.type.option'|translate}}</ng-option>
          </ng-select>
          <div class="messages text-danger"
               *ngIf="type.invalid && type.dirty && type.errors?.required">
            {{'errors.required'|translate}}
          </div>
        </div>
        <div class="form-group form-default form-static-label col-6"
             *ngIf="newOption.type==getOption().OPTION_TYPE_FABRIC">
          <label class="float-label">{{'doctrine.option.fabric_collection'|translate}} <span
            class="star">*</span></label>
          <ng-select [items]="fabricCollectionsForOptions"
                     bindLabel="title"
                     bindValue="id"
                     groupBy="fabrics"
                     name="fabricsForOptions" #fabricsForOptions="ngModel"
                     [multiple]="true"
                     required="true"
                     (change)="changeFabricsForOptions($event)"
                     [(ngModel)]="selectedFabrics"
          >
            <ng-template ng-optgroup-tmp let-item="item">
              {{item.title}}
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              {{item.title}}
            </ng-template>
          </ng-select>


          <div class="messages text-danger"
               *ngIf="fabricsForOptions.invalid && fabricsForOptions.dirty && fabricsForOptions.errors?.required">
            {{'errors.required'|translate}}
          </div>
        </div>
        <div class="form-group form-default form-static-label col-6"
             *ngIf="newOption.type!=getOption().OPTION_TYPE_FABRIC">
          <label class="float-label">{{'doctrine.option.parent'|translate}} <span class="star">*</span></label>
          <ng-select class="ng-select" name="parentItem"
                     #parentItem="ngModel"
                     [(ngModel)]="newOption.parent"
                     (change)="parentSelected($event,parents)"
                     [clearable]="false" required>
            <ng-option [value]="parent.id"
                       *ngFor="let parent of parents"
            >{{parent.name}}</ng-option>
          </ng-select>
          <div class="messages text-danger"
               *ngIf="parentItem.invalid && parentItem.dirty && parentItem.errors?.required">
            {{'errors.required'|translate}}
          </div>
        </div>
      </div>

      <div class="form-group row">
        <div class="form-group form-default form-static-label col-6"
             *ngIf="newOption.type==getOption().OPTION_TYPE_FABRIC">
          <label class="float-label">{{'doctrine.option.parent'|translate}} <span class="star">*</span></label>
          <ng-select class="ng-select" name="parentItem" #parentItem="ngModel" [(ngModel)]="newOption.parent"
                     [clearable]="false" required>
            <ng-option [value]="parent.id" *ngFor="let parent of parents">{{parent.name}}</ng-option>
          </ng-select>
          <div class="messages text-danger"
               *ngIf="parentItem.invalid && parentItem.dirty && parentItem.errors?.required">
            {{'errors.required'|translate}}
          </div>
        </div>
        <div class="form-group form-default form-static-label col-6">
          <label class="float-label">{{'doctrine.option.factory_code'|translate}}</label>
          <input type="text" [name]="'factoryCode'" #code="ngModel" [(ngModel)]="newOption.factoryCode" class="form-control">
        </div>
        <div class="col-sm-6 border-checkbox-section d-flex align-items-center pt-4">
          <div class="border-checkbox-group border-checkbox-group-primary">
            <input type="checkbox" [id]="'requiredItem'" class="border-checkbox" [name]="'requiredItem'"
                   #requiredItem="ngModel"
                   [(ngModel)]="newOption.required">
            <label class="border-checkbox-label mb-0"
                   [for]="'requiredItem'">{{'admin.backoffice.option.show.add_option.is_required'|translate}}</label>
          </div>
        </div>
        <div class="col-sm-6 border-checkbox-section d-flex align-items-center pt-4">
          <div class="border-checkbox-group border-checkbox-group-primary">
            <input type="checkbox" [id]="'hasProductionForms'" class="border-checkbox" [name]="'hasProductionForms'"
                   #hasProductionForms="ngModel"
                   [(ngModel)]="newOption.hasProductionForms">
            <label class="border-checkbox-label mb-0"
                   [for]="'hasProductionForms'">{{'admin.backoffice.option.show.has_production_forms'|translate}}</label>
          </div>
        </div>
      </div>
      <h4 class="sub-title">{{'doctrine.option.price' |translate}}</h4>
      <div class="form-group row">
        <div class="col-sm-4">
          <label class="float-label">{{'doctrine.option.dealer_price'|translate}}</label>

          <div class="input-group">
             <span class="input-group-append">
              <label class="input-group-text">{{'global.currency_sign'|translate}}</label>
            </span>
            <input type="text"
                   name="dealerPriceItem"
                   #dealerPriceItems="ngModel"
                   [(ngModel)]="newOption.dealerPrice"
                   pattern="\d+([.]\d+)?"
                   class="form-control">

            <div class="messages text-danger"
                 *ngIf="dealerPriceItems.invalid && dealerPriceItems.dirty && dealerPriceItems.errors?.pattern">
              {{'errors.invalid'|translate}}
            </div>

          </div>
        </div>
        <div class="col-sm-4">
          <label class="float-label">{{'doctrine.option.customer_price'|translate}}</label>
          <div class="input-group">
             <span class="input-group-append">
              <label class="input-group-text">{{'global.currency_sign'|translate}}</label>
            </span>
            <input type="text"
                   name="customerPriceItem"
                   #customerPriceItems="ngModel"
                   [(ngModel)]="newOption.customerPrice"
                   pattern="\d+([.]\d+)?"
                   class="form-control">

            <div class="messages text-danger"
                 *ngIf="customerPriceItems.invalid && customerPriceItems.dirty && customerPriceItems.errors?.pattern">
              {{'errors.invalid'|translate}}
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <label class="float-label">{{'doctrine.option.price_multiplier'|translate}}</label>
          <ng-select class="ng-select" name="priceMultiplierItem" #priceMultiplierItems="ngModel"
                     [(ngModel)]="newOption.priceMultiplier">
            <ng-option [value]="priceMultiplier.id"
                       *ngFor="let priceMultiplier of properties">{{priceMultiplier.name}}</ng-option>
          </ng-select>
          <div class="messages text-danger"
               *ngIf="priceMultiplierItems.invalid && priceMultiplierItems.dirty">
            {{'errors.required'|translate}}
          </div>
        </div>
        <div class="col-sm-4 border-checkbox-section d-flex align-items-center pt-4">
          <div class="border-checkbox-group border-checkbox-group-primary">
            <input type="checkbox" [id]="'requiresCustomerDetails'" class="border-checkbox"
                   [name]="'requiresCustomerDetails'" data-testid="option-requires-customer-details"
                   #requiresCustomerDetailsItem="ngModel"
                   [(ngModel)]="newOption.requiresCustomerDetails">
            <label class="border-checkbox-label mb-0"
                   [for]="'requiresCustomerDetails'">{{'doctrine.option.requires_customer_details'|translate}}</label>
          </div>
        </div>
        <!-- POS-D08: the term and the electrical flag are explicit configuration, never
             inferred from the option's (renameable, translatable) name. PosOptionTermResolver
             throws on the export and the POS overview until both are set here. -->
        <div class="col-sm-4" *ngIf="newOption.requiresCustomerDetails">
          <label class="float-label">{{'doctrine.option.pos_term_years'|translate}}</label>
          <input type="number" min="1" name="posTermYearsItem" data-testid="option-pos-term-years"
                 #posTermYearsItem="ngModel" [(ngModel)]="newOption.posTermYears" class="form-control">
        </div>
        <div class="col-sm-4 border-checkbox-section d-flex align-items-center pt-4"
             *ngIf="newOption.requiresCustomerDetails">
          <div class="border-checkbox-group border-checkbox-group-primary">
            <input type="checkbox" [id]="'posIsElectrical'" class="border-checkbox"
                   [name]="'posIsElectrical'" data-testid="option-pos-is-electrical"
                   #posIsElectricalItem="ngModel"
                   [(ngModel)]="newOption.posIsElectrical">
            <label class="border-checkbox-label mb-0"
                   [for]="'posIsElectrical'">{{'doctrine.option.pos_is_electrical'|translate}}</label>
          </div>
        </div>
      </div>
      <h4 class="sub-title">{{'doctrine.option.parts' |translate}}</h4>
      <div class="form-group row">
        <div class="col-12 border-checkbox-section d-flex align-items-center pb-4">
          <div class="border-checkbox-group border-checkbox-group-primary">
            <input type="checkbox" [id]="'needsParts'" class="border-checkbox" [name]="'needsParts'"
                   #requiredItem="ngModel" (change)="onHasPartOptionChange($event)"
                   [(ngModel)]="optionHasPart">
            <label class="border-checkbox-label mb-0"
                   [for]="'needsParts'">{{'admin.backoffice.option.add_option.needs_parts'|translate}}</label>
          </div>
        </div>
        <div class="col-sm-1"></div>
        <div *ngIf="optionHasPart" class="col-12">
          <app-parts-table 
            [parts]="newOption.partOptions"
            [showTable]="optionHasPart && newOption.partOptions?.length > 0"
            (updateAmount)="updatePartAmount($event)"
            (removePart)="removePart($event)">
          </app-parts-table>
        </div>

        <div class="px-4 mb-4 pull-left" *ngIf="optionHasPart">
          <button class="btn btn-primary ripple light" (click)="showPartGrid()">
            <span class="feather icon-plus"></span><span>{{'admin.option.show.add.part'|translate}}</span>
          </button>
        </div>
      </div>
      <h4 class="sub-title">{{'doctrine.option.extra_fabric' |translate}}</h4>
      <div class="form-group row">
        <div class="col-sm-6 border-checkbox-section d-flex align-items-center pb-4">
          <div class="border-checkbox-group border-checkbox-group-primary">
            <input type="checkbox" [id]="'needsFabric'" class="border-checkbox" [name]="'needsFabric'"
                   #requiredItem="ngModel"
                   [(ngModel)]="newOption.needsFabric">
            <label class="border-checkbox-label mb-0"
                   [for]="'needsFabric'">{{'admin.backoffice.option.add_option.needs_fabric'|translate}}</label>
          </div>
        </div>
        <div class="col-sm-1"></div>
        <div *ngIf="newOption.needsFabric" class="col-sm-5">
          <label class="float-label">{{'doctrine.option.fabric_amount'|translate}}</label>
          <div class="input-group">
            <input type="text"
                   name="fabricAmount"
                   #fabricAmount="ngModel"
                   [(ngModel)]="newOption.fabricAmount"
                   pattern="\d+([.]\d+)?"
                   class="form-control">

            <div class="messages text-danger"
                 *ngIf="fabricAmount.invalid && fabricAmount.dirty && fabricAmount.errors?.pattern">
              {{'errors.invalid'|translate}}
            </div>
          </div>
        </div>
      </div>
    </form>

  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4"
            (click)="optionModal.hide();addNewOption.reset();">
      {{'global.cancel'|translate}}
    </button>
    <button type="button" class="btn btn-primary ripple light" (click)="submitOption()"
            [disabled]="checkDisability">
      {{(isEdit ? 'global.save_changes' : 'global.actions.add') | translate}}</button>
  </div>
</app-modal-basic>

<!--
end add sub option modal
-->

<ng-template #tree let-allItems let-idx="idx">
  <ng-container *ngFor="let item of allItems; let n = index">
    <tr>
      <td>{{ calculate(idx)}}{{item.name}}</td>
      <td>{{item.type}}</td>
      <td>{{((item.required) ? 'global.yes' : 'global.no')|translate}}</td>
      <td>{{item.dealerPrice| BackofficeCurrency:'EUR':'symbol-narrow':'4.2-2'}}</td>
      <td>{{item.customerPrice| BackofficeCurrency:'EUR':'symbol-narrow':'4.2-2'}}</td>
      <td>{{item.priceMultiplier ? item.priceMultiplier.name : ''}}</td>
      <td>
        <input class="form-control" (blur)="positionChange(item.id,item.parentPosition)" name="positionItem"
               type="number" [(ngModel)]="item.parentPosition" #positionItem="ngModel" style="max-width: 60px">
      </td>
      <!--<td>{{ option.code }}</td>-->
      <!--<td>{{option.status ? getOption().OPTION_ACTIVE : getOption().OPTION_INACTIVE}}</td>-->
      <td>
        <ng-container *ngIf="archive">
          <span class="action-button">
            <a class="ripple light ms-2"
                 (click)="showReAddForSubOption(item.id, item.name)">
              <i class="fa fa-plus fa-lg"></i>
            </a>
          </span>
        </ng-container>
        <ng-container *ngIf="!archive">
          <span class="action-button">
            <a class="ripple light ms-2" (click)="manageOption(item)">
            <i class="fa fa-pencil fa-lg"></i>
          </a>
          </span>
          <span class="action-button">
            <a class="ripple light ms-2"
               (click)="setDetailForSoftDelete(item.id, item.name)">
            <i class="fa fa-remove fa-lg"></i>
          </a>
          </span>
        </ng-container>
      <td>
    </tr>
    <ng-container *ngIf="item.options">
      <ng-container *ngTemplateOutlet="tree; context: { $implicit: item.options, idx: idx + '.' + n}"></ng-container>
    </ng-container>
  </ng-container>
</ng-template>


<ng-template #itemTemplate let-item="item" let-onCollapseExpand="onCollapseExpand"
             let-onCheckedChange="onCheckedChange">
  <div class="form-inline row-item">
    <i *ngIf="item.children" (click)="onCollapseExpand()" aria-hidden="true" class="fa"
       [class.fa-caret-right]="item.collapsed"
       [class.fa-caret-down]="!item.collapsed"></i>
    <div class="form-check">
      <input type="checkbox" class="form-check-input" [(ngModel)]="item.checked" (ngModelChange)="onCheckedChange()"
             [disabled]="item.disabled"
             [indeterminate]="item.indeterminate"/>
      <label class="form-check-label" (click)="item.checked = !item.checked; onCheckedChange()">
        {{item.text}}
      </label>
    </div>
  </div>
</ng-template>

<!--
  Re Add Modal
 -->
<app-modal-basic #reAddModal>
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'global.soft_readd_title' | translate:{entity: 'Option'} }}</h4>
    <button type="button" class="close basic-close" (click)="deleteModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p>{{ 'global.soft_readd_body' | translate}}: <b [innerHTML]="optionName"></b> ?</p>
    <div class="form-group row">
    </div>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4"
            (click)="reAddModal.hide()">{{'global.cancel'|translate}}</button>
    <button type="button" class="btn btn-primary ripple light"
            (click)="reAddSubOption()">{{'global.actions.readd'|translate}}</button>
  </div>
</app-modal-basic>

<!--add part Modal-->
<app-modal-basic #partsModal [dialogClass]="'modal-lg'">
  <div class="app-modal-header">
    <h4 class="modal-title">{{'global.modal.add_part'|translate}}</h4>
    <button type="button" class="close basic-close" (click)="cancelPartModel()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <app-grid [grid]="partsGrid" *ngIf="showPartModal" (selectedDataRows)="addPart($event)"
              [removeSelected]="removeSelectedPart"></app-grid>
  </div>
  <!--modal button-->
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-2"
            (click)="cancelPartModel()">{{'global.cancel'|translate}}</button>
    <button type="button" class="btn btn-primary ripple light"
            (click)="addToPart()">{{'global.add'|translate}}</button>
  </div>
</app-modal-basic>